import * as React from "react";
export class EventCardSectionItem extends React.PureComponent {
    render() {
        return (React.createElement("div", { className: `rj-ev-list__ev-card__section-item ${this.props.className || ""}`, "data-uat": "div-ev-list-ev-card-section-item" }, this.props.content));
    }
}
//# sourceMappingURL=EventCardSectionItem.js.map